const state = {
  preview: [],
  lastSelectedEntityTypes: [],
  loading: false,
  error: null,
  bitrixAuth: null,
  isBitrix: false,
  isBitrixLinked: false,
  isBitrixConnectionValid: true,
};

export default state;
